import { useState } from 'react';
import './styles.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import 'react-tabs/style/react-tabs.css';
import { InputText } from 'primereact/inputtext';
import api from 'src/services/api';

export default function CadastroDeProjeto(props) {
  const [nomeProjeto, setNomeProjeto] = useState('');
  const [clienteAssociado, setClienteAssociado] = useState('');

  const breadcrumbItems = [
    { label: 'Configurações', url: '/configuracoes' },
    { label: 'Projetos', url: '/projetos' },
    { label: 'Cadastro de Projeto', url: '/projetos' },
  ];

  const handleCriarProjeto = async (event) => {
    event.preventDefault();

    try {
      const response = await api.post('/api/clientes', {
        nomeProjeto: nomeProjeto,
        clienteAssociado: clienteAssociado,
      });

      if (response.data.success) {
        alert('Projeto criado com sucesso!');
      } else {
        alert('Erro ao criar projeto. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Erro:', error);
      alert(
        'Ocorreu um erro ao criar o projeto. Por favor, tente novamente mais tarde.',
      );
    }
  };

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <BreadCrumb
        model={breadcrumbItems}
        home={{ label: 'Home', url: '/' }}
        style={{
          marginTop: '-33px',
          marginRight: '600px',
          border: 'none',
          color: '#B7D400!important',
        }}
      />

      <p
        style={{
          fontSize: '35px',
          fontStyle: 'normal',
          fontWeight: '700',
          color: '#006998',
          marginTop: '-15px',
        }}
      >
        Cadastro de Projeto
      </p>
      <div
        style={{ width: '1000px', display: 'flex', justifyContent: 'center' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1372"
          height="10"
          viewBox="0 0 1372 10"
          fill="none"
        >
          <g filter="url(#filter0_d_110_89)">
            <path
              d="M4 1L1368 1.00012"
              stroke="#006998"
              stroke-opacity="0.55"
              stroke-width="2"
              shape-rendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_110_89"
              x="0"
              y="0"
              width="1372"
              height="10"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0.15 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_110_89"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_110_89"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <form onSubmit={handleCriarProjeto}>
        <fieldset
          style={{
            width: '800px',
            minHeight: '250px',
            height: '300px',
            border: '1px solid #006998',
            marginTop: '35px',
            fontWeight: 'bold',
            color: 'black',
            borderRadius: '8px',
          }}
        >
          <div style={{ display: 'flex', marginTop: '10px' }}>
            <p style={{ marginTop: '10px', fontWeight: '400' }}>
              Nome do Projeto
            </p>
          </div>
          <legend style={{ fontSize: '20px', fontWeight: 400, color: 'black' }}>
            Informações do Projeto
          </legend>
          <InputText
            value={nomeProjeto}
            onChange={(e) => setNomeProjeto(e.target.value)}
            style={{
              width: '80%',
              display: 'flex',
              marginTop: '-10px',
              borderColor: '#006998',
              fontStyle: 'italic',
            }}
            placeholder="Insira aqui o nome do cliente"
          />
          <p style={{ marginTop: '10px', fontWeight: '400' }}>
            Cliente associado
          </p>
          <select
            style={{
              width: '100%',
              height: '45px',
              display: 'flex',
              marginTop: '-10px',
              fontSize: '14px',
              fontStyle: 'italic',
              borderRadius: '5px',
              borderColor: '#006998',
              paddingRight: '30px',
            }}
            value={clienteAssociado}
            onChange={(e) => setClienteAssociado(e.target.value)}
          >
            <option value="">Selecione o cliente associado ao projeto</option>
            <option value="permissao1">Ata 1</option>
            <option value="permissao2">Atas 2</option>
          </select>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}
          >
            <Button
              label="Cancelar"
              className="p-button-outlined p-button-primary"
              style={{ marginLeft: '10px', color: 'red' }}
            />

            <Button
              label="Criar"
              className="p-button-outlined p-button-primary"
              style={{
                marginLeft: '10px',
                color: '#FFF',
                backgroundColor: '#3900DB',
                fontWeight: '400',
              }}
            />
          </div>
        </fieldset>
      </form>
    </div>
  );
}
